import { PortalHost } from '@gorhom/portal';
import React from 'react';

const DropdownContent = () => <PortalHost name="picker-dropdown" />;

export default DropdownContent;
